/**
 * Records the Order.
 */
var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function recordPrintOrder(sState, printPrice, status, license, licenseexpiry, template, dispatch) {

    const abortController = new AbortController();
    let dataProducts = sState.print.layer;
    if (sState.dlayer.length > 0){
      sState.dlayer.forEach(function (d) {
        if (dataProducts !== ''){ dataProducts += ','; }
                dataProducts += d;
      });
    }
    
    const request = {   
        userid:sState.userid,
        accountid:sState.aid,
        product:dataProducts,
        userref: sState.userreference,
        projectname: sState.projectreference,
        price:printPrice.price,
        royalty:0,
        vat:printPrice.vat,
        sessionid:sState.ident,
        ordertype: 'print',
        status: status,
        license: license,
        licenseexpiry: licenseexpiry,
        geometry:sState.printframeextent,
        template:template,
        filetype:sState.print.format,
    };

    let mounted = true;
    (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/order/print', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request),
        signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          let oid = 0;
          if (data.status === "success"){ oid = data.orderid; } else { oid = -1; }
          dispatch({
            type: "setorderid",
            payload: { orderid: oid}
          });
        }
        const cleanup = () => {
            mounted = false;
            abortController.abort();
        };
        return cleanup;
    
    })();

}
